module.exports = __webpack_public_path__ + "img/safari-step-2.cdf5efa7.svg";